/**
 * Drop Down
 *
 * @returns {void}
 */
const dropdown = () => {
    let element;

    const selector = '.js-dropdown';
    const droppedClass = 'is-dropped';

    const $dropdown = $(selector);

    $dropdown.on('click', function () {
        element = $(this);

        if (element.hasClass(droppedClass)) {
            element.removeClass(droppedClass);
        } else {
            $dropdown.removeClass(droppedClass);
            element.addClass(droppedClass);
        }

    });

    $(document).on('click', (event) => {
        if (!$(event.target).closest(selector).length) {
            $dropdown.removeClass(droppedClass);
        }
    })
};

export default dropdown;
